module.exports = __webpack_public_path__ + "static/ceremony-e8b48c51264763dbd8b8483d3d26ecd8.png";